/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getSecondaryComponent, getSecondaryFlyoutComponent } from "selectors/documentSelectors";
import SecondaryPanel from "components/quickTools/Secondary/SecondaryPanel";

const mapStoreToProps = (stores, props) => ({
  ...props,
  panelConfig: getSecondaryComponent(stores),
  flyoutConfig: getSecondaryFlyoutComponent(stores),
  closeFlyoutCallback: () => {
    stores.documentStore.resetSecondaryFlyout();
  }
});

const SecondaryPanelContainer = inject(mapStoreToProps)(SecondaryPanel);

export { SecondaryPanelContainer };
